/**
 * Document title with the unread-notification count: "(3) Khoản thu · CRM Nguyên Bình".
 * AppShell sets the page part, the notification bell sets the count; either can change without clobbering the other.
 */
let base = typeof document !== 'undefined' ? document.title : '';
let count = 0;

export function titleWithCount(title: string, unread: number): string {
  if (unread <= 0) return title;
  return `(${unread > 99 ? '99+' : unread}) ${title}`;
}

function apply() {
  if (typeof document !== 'undefined') document.title = titleWithCount(base, count);
}

export const titleBadge = {
  setBase(title: string) {
    base = title;
    apply();
  },
  setCount(unread: number) {
    count = unread;
    apply();
  },
};
